import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export const fncPopulateFactories = ({ commit, dispatch, state, rootState }, payload) => {
	if (state.factoryList.length == 0 || (payload != undefined && payload.refresh == true)) {
		var objAuth = JSON.parse(rootState.objAuthorize);
		var factoryDetails = {
			a: 'get_factory_data',
			params: {
				manufacturer: objAuth.manufacturer,
				user: objAuth.id
			}
		};
		Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Factory.php', { params: factoryDetails }, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				console.log(error);
			}).then(data => {
				commit('setFactoryList', data);
			});
	}
};

export const fncAddFactory = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var factoryDetails = {
		params: {
			name: payload.name,
            description: payload.description,
            address: payload.address,
            manufacturer: objAuth.manufacturer
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Factory.php?a=create', factoryDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured while trying to add the factory', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The factory was added successfully', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
			dispatch({
				type: 'fncPopulateFactories',
                refresh: true
			})
		})
};

export const fncUpdateFactory = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var factoryDetails = {
		params: {
			id: payload.editFactory.id,
			name: payload.editFactory.name,
			description: payload.editFactory.description,
			address: payload.editFactory.address,
			manufacturer: objAuth.manufacturer
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Factory.php?a=edit', factoryDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured while trying to update the factory', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The factory was updated successfully', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
			dispatch({
				type: 'fncPopulateFactories',
				refresh: true
			})
		})
};

export const fncDeleteFactory = ({ commit, dispatch, state, rootState }, payload) => {
	var deleteDetails = {
		params: {
			id: payload.factoryId
		}
	};
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Factory.php?a=delete', deleteDetails, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            var snackDetails = {color: 'error', message: 'An error has occured while trying to delete the factory', display: true};
            commit('setSnack', snackDetails);
        }).then(data => {
        var snackDetails = {color: 'success', message: 'The factory was removed successfully', display: true};
        commit('setSnack', snackDetails);
		dispatch({
			type: 'fncPopulateFactories',
			refresh: true
		})
    })
};

export const fncPopulatePackages = ({ commit, dispatch, state, rootState }, payload) => {
	if (state.packageList.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true))) {
		var objAuth = JSON.parse(rootState.objAuthorize);
		var packageDetails = {
			a: 'get_packages',
			params: {
				manufacturer: objAuth.manufacturer,
				user: objAuth.id
			}
		};
		Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Package.php', { params: packageDetails }, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				console.log(error);
			}).then(data => {
				commit('setPackageList', data);
				if (payload != undefined && payload.reload == true) {
					var snackDetails = { color: 'success', message: 'Packages reload successfull', display: true };
					commit('setSnack', snackDetails);
				}
				commit('fncSetPackagesLoaded', true);
			});
	} else {
		commit('fncSetPackagesLoaded', true);
	}
};

export const fncDeletePackage = ({ commit, dispatch, state, rootState }, payload) => {
	var deleteDetails = {
		params: {
			id: payload.packageId
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Package.php?a=delete', deleteDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured while trying to delete the factory', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The package was removed successfully', display: true };
			commit('setSnack', snackDetails);
			dispatch({
				type: 'fncPopulatePackages',
                refresh: true
			});
			//dispatch('fncPopulatePackages');
		})
};

export const fncPopulateVehicles = ({ commit, dispatch, state, rootState }, payload) => {
	if (state.vehicleList.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true))) {
		var objAuth = JSON.parse(rootState.objAuthorize);
		var vehicleDetails = {
			a: 'get_vehicles',
			params: {
				manufacturer: objAuth.manufacturer,
				user: objAuth.id
			}
		};
		Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vehicle.php', { params: vehicleDetails }, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				console.log(error);
			}).then(data => {
				commit('setVehicleList', data);
				if (payload != undefined && payload.reload == true) {
					var snackDetails = { color: 'success', message: 'Vehicles reload successfull', display: true };
					commit('setSnack', snackDetails);
				}
				commit('fncSetVehiclesLoaded', true);
			});
	} else {
		commit('fncSetVehiclesLoaded', true);
	}
};


export const fncDeleteVehicle = ({ commit, dispatch, state, rootState }, payload) => {
	var deleteDetails = {
		params: {
			id: payload.vehicleId
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vehicle.php?a=delete', deleteDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured while trying to delete the vehicle', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The vehicle was removed successfully', display: true };
			commit('setSnack', snackDetails);
			dispatch({
				type: 'fncPopulateVehicles',
                refresh: true
			})
			//dispatch('fncPopulateVehicles');
		})
};

export const fncPopulateProductConfig = ({ commit, dispatch, state, rootState }, payload) => {
	if (state.productConfig.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true ))) {
		var objAuth = JSON.parse(rootState.objAuthorize);
		Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				var snackDetails = { color: 'error', message: 'An error has occured', display: true };
				commit('setSnack', snackDetails);
				console.log(error);
			}).then(data => {
				var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, 'default': 1 };
				Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
					.then(response => {
						return response.json();
					}, error => {
						var snackDetails = { color: 'error', message: 'An error has occured', display: true };
						commit('setSnack', snackDetails);
						console.log(error);
					}).then(dt => {
						var priceList = dt[0];
						var listDetails = { token: data.token, list_id: priceList.pl_id }
						Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelist_items', { params: listDetails }, rootState.headerDetails)
							.then(response => {
								return response.json();
							}, error => {
								var snackDetails = { color: 'error', message: 'An error has occured', display: true };
								commit('setSnack', snackDetails);
								console.log(error);
							}).then(d => {
								var configDetails = {
									params: {
										manufacturer: objAuth.manufacturer,
									}
								};
								Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'ProductConfig.php?a=get_p_cfg_data', configDetails, rootState.headerDetails)
									.then(response => {
										return response.json();
									}, error => {
										var snackDetails = { color: 'error', message: 'An error has occured while trying to retrieve the product config', display: true };
										commit('setSnack', snackDetails);
									}).then(pconfig => {
										commit({
											type: 'setProductConfig',
											config: pconfig,
											products: d
										})
										if (payload != undefined && payload.reload == true) {
											var snackDetails = { color: 'success', message: 'Product Configuration reload successfull', display: true };
											commit('setSnack', snackDetails);
										}
									})
							});
					});
			});
	}

};

export const fncSaveConfig = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var objConfigs = [];
	for (var p in state.productConfig.products) {
		var calcMode = state.productConfig.products[p].calc_mode == null ? 1 : state.productConfig.products[p].calc_mode;
		var normalizeQty = state.productConfig.products[p].normalize_qty == true ? 1 : 0;
		var factories = state.productConfig.products[p].factories == undefined ? 'null' : state.productConfig.products[p].factories;
		objConfigs.push({ code: state.productConfig.products[p].pli_code, factories: factories, calc_mode: calcMode, normalize_qty: normalizeQty });
		if (objConfigs.length == 1000) {
			var configDetails = {
				params: {
					manufacturer: objAuth.manufacturer,
					items: objConfigs
				}
			};
			Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'ProductConfig.php?a=save_p_cfg', configDetails, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					var snackDetails = { color: 'error', message: 'An error has occured while trying to update the product config' + p, display: true };
					commit('setSnack', snackDetails);
				}).then(pconfig => {
				})
			objConfigs = [];
		}
	}

	setTimeout(function () {
		var configDetails = {
			params: {
				manufacturer: objAuth.manufacturer,
				items: objConfigs
			}
		};
		Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'ProductConfig.php?a=save_p_cfg', configDetails, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				var snackDetails = { color: 'error', message: 'An error has occured while trying to update the product config' + p, display: true };
				commit('setSnack', snackDetails);
			}).then(pconfig => {
				var snackDetails = { color: 'success', message: 'The product configuration was updated succesfully', display: true };
				commit('setSnack', snackDetails);
				commit('setRunSave', false);
				dispatch({
					type: 'fncPopulateProductConfig',
                    refresh: true
				})
			})
	}, 5000)
}

export const fncPopulateMatrix = ({ commit, dispatch, state, rootState }, payload) => {
	if (state.transportMatrix.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true))) {
		var objAuth = JSON.parse(rootState.objAuthorize);
		Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				var snackDetails = { color: 'error', message: 'An error has occured', display: true };
				commit('setSnack', snackDetails);
				console.log(error);
			}).then(data => {
				var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, 'default': 1 };
				Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
					.then(response => {
						return response.json();
					}, error => {
						var snackDetails = { color: 'error', message: 'An error has occured', display: true };
						commit('setSnack', snackDetails);
						console.log(error);
					}).then(dt => {
						var priceList = dt[0];
						var listDetails = { token: data.token, list_id: priceList.pl_id }
						Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelist_items', { params: listDetails }, rootState.headerDetails)
							.then(response => {
								return response.json();
							}, error => {
								var snackDetails = { color: 'error', message: 'An error has occured', display: true };
								commit('setSnack', snackDetails);
								console.log(error);
							}).then(d => {
								var tcmDetails = {
									params: {
										manufacturer: objAuth.manufacturer,
									}
								};
								Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Tcm.php?a=get_tcm', tcmDetails, rootState.headerDetails)
									.then(response => {
										return response.json();
									}, error => {
										var snackDetails = { color: 'error', message: 'An error has occured while trying to retrieve the product config', display: true };
										commit('setSnack', snackDetails);
									}).then(tcm => {
										commit({
											type: 'setTransportMatrix',
											tcm: tcm,
											products: d
										})
										if (payload != undefined && payload.reload == true) {
											var snackDetails = { color: 'success', message: 'Cost Matrix reload successfull', display: true };
											commit('setSnack', snackDetails);
										}
									})
							});
					});
			});
	}
}

export const fncPopulateStructure = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var structureDetails = {
		params: {
			manufacturer: objAuth.manufacturer
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Tcm.php?a=get_structure', structureDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured while trying to add the factory', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			commit('fncPopulateStructure', data);
		})
}

export const fncSaveStructure = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var items = [];
	for (var k in state.transportStructure ) {
		items.push(state.transportStructure[k].radius);
	}
	var structureDetails = {
		params: {
			manufacturer: objAuth.manufacturer,
            items: items
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Tcm.php?a=save_structure', structureDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured while trying to add the factory', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The radius was updated successfully', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		})
}

export const fncAddPackage = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var objProducts = [];
	if (state.objPackageAdd != '') {
		for (var k in state.objPackageAdd) {
			objProducts.push({ id: state.objPackageAdd[k].product_code, uom: '', capacity: state.objPackageAdd[k].capacity });
		}
	}
	var packageDetails = {
		params: {
			name: payload.name,
			short_name: payload.shortName,
			description: payload.description,
            products: objProducts,
			current_user: objAuth.id,
			manufacturer: objAuth.manufacturer
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Package.php?a=create', packageDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured while trying to add the package', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The package was added successfully', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
			dispatch({
				type: 'fncPopulatePackages',
                refresh: true
			})
		})
}

export const fncEditPackage = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var objProducts = [];
	if (state.objPackageEditProducts != '') {
		for (var k in state.objPackageEditProducts) {
			objProducts.push({ id: state.objPackageEditProducts[k].product_code, uom: '', capacity: state.objPackageEditProducts[k].capacity});
		}
	}
	var packageDetails = {
		params: {
			id: state.objPackageEdit.package.id,
			name: state.objPackageEdit.package.name,
			short_name: state.objPackageEdit.package.short_name,
			description: state.objPackageEdit.package.description,
            products: objProducts,
			current_user: objAuth.id,
			manufacturer: objAuth.manufacturer
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Package.php?a=edit', packageDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured while trying to update the package', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The package was updated successfully', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
			dispatch({
				type: 'fncPopulatePackages',
				refresh: true
			})
		})
}

export const fncAddVehicle = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var objPackages = [];
	for (var k in state.objVehicleAddSelectedPackages) {
		objPackages.push({ package: state.objVehicleAddSelectedPackages[k].package, quantity: state.objVehicleAddSelectedPackages[k].quantity });
	}
	var objMatrix = [];
	for (var k in state.objVehicleAddMatrix) {
		objMatrix.push({ distance: state.objVehicleAddMatrix[k].distance, cost: state.objVehicleAddMatrix[k].cost });
	}
	var vehicleDetails = {
		params: {
			name: payload.name,
			reg_no: payload.registration,
			description: payload.description,
			packages: objPackages,
			vehicle_min_cost_matrix_items: objMatrix,
			current_user: objAuth.id,
			manufacturer: objAuth.manufacturer
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vehicle.php?a=create', vehicleDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured while trying to add the vehicle', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The vehicle was added successfully', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
			dispatch({
				type: 'fncPopulateVehicles',
				refresh: true
			})
		})
}

export const fncEditVehicle = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var objPackages = [];
	for (var k in state.objVehicleEditSelectedPackages) {
		objPackages.push({ package: state.objVehicleEditSelectedPackages[k].package, quantity: state.objVehicleEditSelectedPackages[k].quantity });
	}
	var objMatrix = [];
	for (var k in state.objVehicleEditMatrix) {
		objMatrix.push({ distance: state.objVehicleEditMatrix[k].distance, cost: state.objVehicleEditMatrix[k].cost });
	}
	var vehicleDetails = {
		params: {
			id: state.objVehicleEdit.id,
			name: state.objVehicleEdit.name,
			reg_no: state.objVehicleEdit.reg_no,
			description: state.objVehicleEdit.description,
            packages: objPackages,
            vehicle_min_cost_matrix_items: objMatrix,
			current_user: objAuth.id,
			manufacturer: objAuth.manufacturer
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vehicle.php?a=edit', vehicleDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured while trying to update the vehicle', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The vehicle was updated successfully', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
			//dispatch('fncPopulateVehicles', data);
			dispatch({
				type: 'fncPopulateVehicles',
				refresh: true
			})
		})
}

export const setObjPackageAdd = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured', display: true };
			commit('setSnack', snackDetails);
			console.log(error);
		}).then(data => {
			var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, 'default': 1 };
			Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					var snackDetails = { color: 'error', message: 'An error has occured', display: true };
					commit('setSnack', snackDetails);
					console.log(error);
				}).then(dt => {
					var priceList = dt[0];
					var listDetails = { token: data.token, list_id: priceList.pl_id }
					Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelist_items', { params: listDetails }, rootState.headerDetails)
						.then(response => {
							return response.json();
						}, error => {
							var snackDetails = { color: 'error', message: 'An error has occured', display: true };
							commit('setSnack', snackDetails);
							console.log(error);
						}).then(d => {
							commit({
								type: 'setObjPackageAdd',
								id: payload.id,
								products: d
							})
						});
				});
		});

};

export const setObjPackageEdit = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured', display: true };
			commit('setSnack', snackDetails);
			console.log(error);
		}).then(data => {
			var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, 'default': 1 };
			Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					var snackDetails = { color: 'error', message: 'An error has occured', display: true };
					commit('setSnack', snackDetails);
					console.log(error);
				}).then(dt => {
					var priceList = dt[0];
					var listDetails = { token: data.token, list_id: priceList.pl_id }
					Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelist_items', { params: listDetails }, rootState.headerDetails)
						.then(response => {
							return response.json();
						}, error => {
							var snackDetails = { color: 'error', message: 'An error has occured', display: true };
							commit('setSnack', snackDetails);
							console.log(error);
						}).then(d => {
							var packageDetails = {
								params: {
									manufacturer: objAuth.manufacturer,
									package: payload.id
								}
							};
							Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Package.php?a=get_products', packageDetails, rootState.headerDetails)
								.then(response => {
									return response.json();
								}, error => {
									var snackDetails = { color: 'error', message: 'An error has occured while trying to retrieve the product config', display: true };
									commit('setSnack', snackDetails);
								}).then(pproducts => {
									var modalDetails = { title: 'Edit Package', component: 'modal-package-edit', mstate: true, params: {} };
									commit({
										type: 'setModal',
										details: modalDetails
									});
									commit({
										type: 'setObjPackageEdit',
                                        id: payload.id,
										packageProducts: pproducts,
										products: d
									})
								})
						});
				});
		});

};

export const setObjVehicleEdit = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var vehicleDetails = {
		params: {
			id: state.objVehicleEdit.id,
			manufacturer: objAuth.manufacturer
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vehicle.php?a=get_packages', vehicleDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(packages => {
			var matrixDetails = {
				params: {
					id: state.objVehicleEdit.id
				}
			};
			Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vehicle.php?a=get_min_cost_matrix', matrixDetails, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					console.log(error);
				}).then(matrix => {
					commit({
						type: 'fncSetVehicleOptions',
                        packages: packages,
                        matrix: matrix
					})
					var modalDetails = { title: 'Edit Vehicle', component: 'modal-vehicle-edit', mstate: true, params: {} };
					commit({
						type: 'setModal',
						details: modalDetails
					});
				});
		});

};

export const setObjVehicleAdd = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var vehicleDetails = {
		params: {
			id: 0,
			manufacturer: objAuth.manufacturer
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vehicle.php?a=get_packages', vehicleDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(packages => {
			commit({
				type: 'setObjVehicleAdd',
				packages: packages
			})
		});

};

export const fncSaveMatrix = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var items = [];
	var radius = [];
	for (var r in state.transportMatrix.structure) {
		radius.push(state.transportMatrix.structure[r].id);
	}
	for ( var k in state.transportMatrix.tcmItems ) {
		items.push({ id: state.transportMatrix.tcmItems[k].id, radius: radius, cost: state.transportMatrix.tcmItems[k].radius_cost, product_code: state.transportMatrix.tcmItems[k].product_code, uom: state.transportMatrix.tcmItems[k].uom, structure_length: radius.length });
	}
	var tcmDetails = {
		params: {
			manufacturer: objAuth.manufacturer,
            items: items
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Tcm.php?a=save_tcm', tcmDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(packages => {
			var snackDetails = { color: 'success', message: 'The transport matrix costs was updated successfully', display: true };
			commit('setSnack', snackDetails);
		});
};
